/** Plain wording for a countdown to an expiry date, shared by the web registers
 * and the native app. Pure, so it carries no React or DOM weight into either.
 */

export function describeDaysLeft(daysLeft: number): string {
  if (daysLeft < 0) {
    const n = -daysLeft;
    return `expired ${n} ${n === 1 ? 'day' : 'days'} ago`;
  }
  if (daysLeft === 0) return 'expires today';
  return `expires in ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}`;
}
